import { useNotesStore } from "~/stores/useNotesStore";
import { useMusicStore } from "~/stores/useMusicStore";
import { useShallow } from "zustand/shallow";

/**
 * Custom hook to access note generator state from Zustand stores
 *
 * This hook provides a simple interface to the note generation
 * state that is managed at the store level (persists across routes).
 *
 * Uses shallow comparison to prevent unnecessary re-renders when
 * creating a derived object from the store.
 */
export function useNoteGenerator() {
  const { isPlaying } = useNotesStore(
    useShallow((state) => ({ isPlaying: state.start }))
  );

  const { currentNote, currentInfo, noteTrigger } = useMusicStore(
    useShallow((state) => ({
      currentNote: state.currentNote,
      currentInfo: state.currentInfo,
      noteTrigger: state.noteTrigger,
    }))
  );

  return {
    isPlaying,
    currentNote,
    currentInfo,
    noteTrigger, // Counter that increments on every note play
  };
}
